import React from 'react';
import { Link } from 'react-router-dom';
import './impact3.css';
import { FaEye, FaHandsHelping, FaUsers, FaChartLine, FaPhone, FaEnvelope, FaRegAddressCard, FaHeart } from 'react-icons/fa';
import { FaHandHoldingMedical } from 'react-icons/fa'; // Add this import at the top
function Impact3() {
  return (
    <div className="eye-care-container">
      {/* Hero Section */}
      <section className="care-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title-h1"><FaEye className="hero-icon" /> Eye Care Awareness Program</h1>
          <p className="hero-subtitle" align="center">Protecting Vision • Promoting Eye Health • Empowering Communities</p>
          <div className="hero-stats">
            <div className="stat-item">
              <FaUsers className="stat-icon" />
              <span>10,000+</span>
              <p>People Reached</p>
            </div>
            <div className="stat-item">
              <FaHeart className="stat-icon" />
              <span>5,000+</span>
              <p>Vision Screenings</p>
            </div>
            <div className="stat-item">
              <FaHandsHelping className="stat-icon" />
              <span>100+</span>
              <p>Awareness Events</p>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="care-content">
        {/* Overview Section */}
        <section className="care-section overview-section">
          <div className="section-header">
            <h2><FaEye className="section-icon" /> Program Overview</h2>
            <div className="section-divider"></div>
          </div>
          <div className="section-body">
            <p>
              The Eye Care Awareness Program is a public health initiative aimed at promoting knowledge about the importance of maintaining good eye health, encouraging regular vision check-ups, and preventing avoidable blindness through early detection and treatment.
            </p>
            <div 
        className="overview-image"
        style={{ backgroundImage: "url('/community.png')" }}
      ></div>
          </div>
        </section>

        {/* Objectives Section */}
        <section className="care-section objectives-section">
          <div className="section-header">
            <h2><FaChartLine className="section-icon" /> Program Objectives</h2>
            <div className="section-divider"></div>
          </div>
          <div className="objectives-grid">
            <div className="objective-card">
              <div className="objective-icon">👁️</div>
              <h3>Awareness</h3>
              <p>Educate the public about eye health and vision care</p>
            </div>
            <div className="objective-card">
              <div className="objective-icon">🧑‍⚕️</div>
              <h3>Early Detection</h3>
              <p>Promote regular eye exams to detect problems early</p>
            </div>
            <div className="objective-card">
              <div className="objective-icon">📢</div>
              <h3>Prevention</h3>
              <p>Encourage healthy habits to prevent vision loss</p>
            </div>
            <div className="objective-card">
              <div className="objective-icon">🤝</div>
              <h3>Community Engagement</h3>
              <p>Work with partners to deliver vision care education</p>
            </div>
          </div>
        </section>

        {/* Activities Section */}
        <section className="care-section activities-section">
          <div className="section-header">
            <h2><FaHandsHelping className="section-icon" /> Program Activities</h2>
            <div className="section-divider"></div>
          </div>
          <div className="activities-timeline">
            <div className="timeline-item">
              <div className="timeline-icon">🏥</div>
              <div className="timeline-content">
                <h3>Free Eye Screenings & Camp</h3>
                <p>Community events offering free eye check-ups</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-icon">🎯</div>
              <div className="timeline-content">
                <h3>Eye Care Awareness Program</h3>
                <p>Public campaigns to raise awareness about eye health</p>

              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-icon">📱</div>
              <div className="timeline-content">
                <h3>Teachers training</h3>
                <p>Training sessions for teachers on eye health education</p>

              </div>
            </div>

            <div className="timeline-item">
  <div className="timeline-icon">
    <FaHandHoldingMedical className="services__icon" aria-hidden="true" />
  </div>
  <div className="timeline-content">
    <h3>Affordable Eye Care Services</h3>
    <p>Providing affordable eye care services to the community</p>
  </div>
</div>

            <div className="timeline-item">
              <div className="timeline-icon">📚</div>
              <div className="timeline-content">
                <h3>Enhance eye care research activity</h3>
                <p>Conducting research to improve eye care practices</p>
              </div>
            </div>

          </div>
        </section>

        {/* Outcomes Section */}
        <section className="care-section outcomes-section">
          <div className="section-header">
            <h2><FaChartLine className="section-icon" /> Expected Outcomes</h2>
            <div className="section-divider"></div>
          </div>
          <div className="outcomes-list">
            <div className="outcome-item">
              <div className="outcome-bullet"></div>
              <p>Greater public awareness of eye health issues</p>
            </div>
            <div className="outcome-item">
              <div className="outcome-bullet"></div>
              <p>Eye Crae Services for Everybody</p>
            </div>
            <div className="outcome-item">
              <div className="outcome-bullet"></div>
              <p>Early diagnosis and treatment of eye diseases</p>
            </div>
            <div className="outcome-item">
              <div className="outcome-bullet"></div>
              <p>Reduction in preventable blindness rates</p>
            </div>
            <div className="outcome-item">
              <div className="outcome-bullet"></div>
              <p>Stronger collaboration with health professionals</p>
            </div>
          </div>
        </section>

        {/* Conclusion Section */}
        <section className="care-section conclusion-section">
          <div className="section-header">
            <h2>Our Vision for a Brighter Tomorrow</h2>
            <div className="section-divider"></div>
          </div>
          <div className="conclusion-content">
            <p>
              The Eye Care Awareness Program envisions a world where no one suffers preventable vision loss. Through public education, community involvement, and easy access to eye care services, we aim to empower individuals to prioritize their eye health and preserve their vision for life.
            </p>
            <div className="quote-box">
              <FaHeart className="quote-icon" />
              <blockquote>
                "Protecting your vision today ensures a brighter, clearer tomorrow."
              </blockquote>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="care-cta">
          <div className="cta-card">
            <h2>Take Charge of Your Eye Health</h2>
            <p>
              Book a free vision screening or attend one of our upcoming events to learn more about caring for your eyes. Early action can save your sight.
            </p>
            <div className="contact-info">
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <span>+94 11 7 700904</span>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <span>community@eyecareinstitute.lk</span>
              </div>
              <div className="contact-item">
                <FaRegAddressCard className="contact-icon" />
                <span>Visit your nearest vision center</span>
              </div>
            </div>
            <Link to="/awarenessprogram"><button className="cta-button">Request a awareness program</button></Link>
          </div>
        </section>
        
      </div>
    </div>
  );
}

export default Impact3;
